module.exports = __webpack_public_path__ + "img/contact.f53f4f94.svg";